import { TicketAssign, TicketCreate, TicketDetailResponse, TicketListResponse, TicketNoteCreate, TicketStatusChange, TicketSummarySchema, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchTickets = async (query, signal) => {
    const params = new URLSearchParams();
    if (query.status !== undefined)
        params.set('status', query.status);
    if (query.priority !== undefined)
        params.set('priority', query.priority);
    if (query.assigneeEmployeeId !== undefined)
        params.set('assigneeEmployeeId', query.assigneeEmployeeId);
    params.set('limit', String(query.limit));
    params.set('offset', String(query.offset));
    return TicketListResponse.parse(await request(`/api/v1/communication/tickets?${params.toString()}`, {
        signal,
    }));
};
export const fetchTicket = async (id, signal) => TicketDetailResponse.parse(await request(`/api/v1/communication/tickets/${id}`, { signal }));
/** Abre um chamado — à mão, ou a partir de uma conversa (`conversationId` herda o cliente já identificado por ela). */
export const createTicket = async (input) => TicketSummarySchema.parse(await request('/api/v1/communication/tickets', {
    method: 'POST',
    body: TicketCreate.parse(input),
}));
/** Muda a situação de um chamado — inclusive fechar (`status: 'closed'`) e reabrir (`status: 'in_progress'` a partir de `closed`). */
export const changeTicketStatus = async (id, input) => TicketSummarySchema.parse(await request(`/api/v1/communication/tickets/${id}/status`, {
    method: 'PATCH',
    body: TicketStatusChange.parse(input),
}));
/** Atribui o chamado a um responsável, ou tira o responsável com `employeeId: null`. */
export const assignTicket = async (id, input) => TicketSummarySchema.parse(await request(`/api/v1/communication/tickets/${id}/assign`, {
    method: 'POST',
    body: TicketAssign.parse(input),
}));
export const addTicketNote = async (id, input) => TicketDetailResponse.parse(await request(`/api/v1/communication/tickets/${id}/notes`, {
    method: 'POST',
    body: TicketNoteCreate.parse(input),
}));
//# sourceMappingURL=communication-tickets.js.map